/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */

import "./index.scss"; // Standard version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
import "react-datepicker/dist/react-datepicker.css";

import * as _redux from "./redux";

import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from "./_metronic/layout";
import store, { persistor } from "./redux/store";

import App from "./app/App";
import { ContactUIProvider } from "./app/modules/ContactDeals/ContactUIContext";
import { CustomerUIProvider } from "./app/modules/Customer/CustomerUIContext";
import { DealsUIProvider } from "./app/modules/ContactDeals/DealsUIContext";
import ErrorBoundary from "./app/pages/ErrorBoundary";
import { MetronicI18nProvider } from "./_metronic/i18n";
import { OrderUIProvider } from "./app/modules/Order/OrderUIContext";
import React from "react";
import { createRoot } from "react-dom/client";
import { TasksUIProvider } from "./app/modules/Tasks/TasksUIContext";
import axios from "axios";
import { QTasksUIProvider } from "./app/modules/Quotes/TasksUIContext";
import { KycUIProvider } from "./app/modules/KycList/KycUIContext";

import { InvoiceUIProvider } from "./app/modules/Invoice/InvoiceUIContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const PUBLIC_URL = "";

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */ _redux.mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store);
const stripePromise = loadStripe(import.meta.env.REACT_APP_STRIPE_PK);

createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <MetronicI18nProvider>
      <MetronicLayoutProvider>
        <MetronicSubheaderProvider>
          <MetronicSplashScreenProvider>
            <Elements stripe={stripePromise}>
              <ContactUIProvider>
                <DealsUIProvider>
                  <CustomerUIProvider>
                    <OrderUIProvider>
                      <TasksUIProvider>
                        <InvoiceUIProvider>
                          <QTasksUIProvider>
                            <KycUIProvider>
                              <App
                                store={store}
                                persistor={persistor}
                                basename={PUBLIC_URL}
                              />
                            </KycUIProvider>
                          </QTasksUIProvider>
                        </InvoiceUIProvider>
                      </TasksUIProvider>
                    </OrderUIProvider>
                  </CustomerUIProvider>
                </DealsUIProvider>
              </ContactUIProvider>
            </Elements>
          </MetronicSplashScreenProvider>
        </MetronicSubheaderProvider>
      </MetronicLayoutProvider>
    </MetronicI18nProvider>
  </ErrorBoundary>
);
